import {
  FULLVISIO_SLOT_TYPE,
  PRESENTIEL_SLOT_TYPE,
  workScheduleBetweenItems,
} from '@omecare/utils';
import { isSameDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { buildPeriodSummaryLabel } from '@/components/forms/slot-period-summary';
import { OfficeDoctorAttendingItem } from '@/hooks/queries/use-get-office';
import { doctorFullnameTitleTrad } from '@/utils/doctor';
import { AddOfficeWorkScheduleSlotUseForm } from './use-add-office-work-schedule-slot-form';

export const useAddOfficeWorkScheduleSlotFormViewModel = ({
  form,
  doctorAttendings,
}: {
  form: AddOfficeWorkScheduleSlotUseForm;
  doctorAttendings: OfficeDoctorAttendingItem[];
}) => {
  const { t } = useTranslation();

  const selectDoctorAttendingOptions = doctorAttendings.map(
    (doctorAttending) => {
      const doctorTrad = doctorFullnameTitleTrad(doctorAttending);
      return {
        id: doctorAttending.id,
        label: t(doctorTrad.key, doctorTrad.params),
        value: doctorAttending.id,
      };
    },
  );

  const selectPeriodOfTheDayOptions = workScheduleBetweenItems.filter(
    (i) => i.id !== 'none',
  );

  const selectSlotTypeOptions = [
    {
      id: PRESENTIEL_SLOT_TYPE,
      value: PRESENTIEL_SLOT_TYPE,
      label: 'add-office-work-schedule-slot-form.slot-type.presentiel',
    },
    {
      id: FULLVISIO_SLOT_TYPE,
      value: FULLVISIO_SLOT_TYPE,
      label: 'add-office-work-schedule-slot-form.slot-type.fullvisio',
    },
  ];

  const periodOfTheDay = form.watch('periodOfTheDay');
  const specificDates = form.watch('specificDates');

  return {
    selectOptions: {
      doctorAttendingOptions: selectDoctorAttendingOptions,
      periodOfTheDayOptions: selectPeriodOfTheDayOptions,
      slotTypeOptions: selectSlotTypeOptions,
    },
    specificSlots: {
      selectedDates: specificDates,
      periodSummaryLabel: buildPeriodSummaryLabel({
        periodOfTheDay,
        translate: t,
      }),
    },
    api: {
      removeSelectedDate: (date: Date) => {
        form.setValue(
          'specificDates',
          specificDates.filter((selected) => !isSameDay(selected, date)),
        );
      },
      clearSelectedDates: () => {
        form.setValue('specificDates', []);
      },
    },
  };
};
